import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

var Switch = function Switch(_a) {
  var _b = _a.disabled,
    disabled = _b === void 0 ? false : _b,
    isOn = _a.isOn,
    onLabel = _a.onLabel,
    offLabel = _a.offLabel,
    _c = _a.onChange,
    onChange = _c === void 0 ? function () {} : _c;
  var containerClassNames = classNames("inline-flex", "items-center", {
    "opacity-50": disabled
  });
  var labelClassNames = classNames("rounded-full", "inline-flex", "transition-backgroundColor", "transition-duration-short", "m-0", "p-[0.125rem]", "h-[1.25rem] tw:h-[30px]", "min-w-[2rem] tw:min-w-[50px]", {
    "bg-dark": disabled || !isOn
  }, {
    "tw:bg-tw-neutral-200": !isOn
  }, {
    "bg-primary tw:bg-tw-primary-500": isOn
  }, {
    "cursor-pointer": !disabled
  });
  var sliderClassNames = classNames("w-full", "bg-lightest tw:bg-white", "rounded-full", "transition-margin", "transition-duration-short", "w-[1rem] tw:w-[1.5rem]", {
    "ml-[0.75rem] tw:ml-[22px]": isOn
  }, {
    "ml-0": !isOn
  });
  var textClassNames = classNames("text-sm", "tw:text-base", "tracking-wide", "ml-sm", "mr-xs", "text-body", "tw:text-tw-secondary-800");
  return /*#__PURE__*/React.createElement("div", {
    className: containerClassNames
  }, /*#__PURE__*/React.createElement("label", {
    className: labelClassNames
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    className: "hidden",
    disabled: disabled,
    onChange: onChange,
    checked: isOn
  }), /*#__PURE__*/React.createElement("span", {
    className: sliderClassNames
  })), onLabel && offLabel && /*#__PURE__*/React.createElement("span", {
    className: textClassNames
  }, isOn ? onLabel : offLabel));
};
Switch.propTypes = {
  isOn: PropTypes.bool.isRequired,
  onLabel: PropTypes.string,
  offLabel: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func
};

export { Switch };
//# sourceMappingURL=index.es.js.map
